import {clearObj} from "utils/clearObj.js";

const EMPTY_LIST = [];

const MessageQueue = () => {
    // a map between message type and list of messages where last element is the last message
    let messages = {}; 

    // list of functions that should be cleared 
    let badSubscribers = [];

    // a map between message type and list of subscribers (which are simply functions)
    let subscribers = {};

    const publish = (type, message) => {
        if (!messages[type]) {
            messages[type] = [];
        }
        messages[type].unshift(message);
        notify(type, message);
    };

    const notify = (type, message) => {
        if (subscribers[type]) {
            subscribers[type].forEach(
                fn => fn(message));
        }
    };

    const subscribe = (type, fn, isBad) => {
        if (!subscribers[type]) {
            subscribers[type] = [];
        }
        subscribers[type] = [fn, ... subscribers[type]];
        if (isBad) {
            badSubscribers.push(fn);
        }
        return () => unsubscribe(type,fn);
    };

    const unsubscribe = (type, fn) => {
        if (!subscribers[type]) {
            return;
        }
        subscribers[type] = subscribers[type].filter(
            f => f !== fn);
    };

    const read = (type) => {
        // return all messages of that type
        return messages[type] || EMPTY_LIST;
    };

    // empties a message type and returns all the messages
    const drain = (type) => {
        let drained = read(type);
        if (messages[type]) {
            messages[type].length = 0;
        }
        return drained;
    };

    const clearQueue = () => {
        clearObj(messages);
        for (let sub of badSubscribers) {
            for (let type in subscribers) {
                subscribers[type] = subscribers[type].filter(
                    fn => fn !== sub);
            }
        }
        badSubscribers.length = 0;
    };

    return {notify, subscribe, publish, read, drain, clearQueue, unsubscribe};
};

export const {notify, unsubscribe, subscribe, publish, read, drain, clearQueue} = MessageQueue();

export const latest = (type) => read(type)[0];

window.subs = subscribe;
